import { MappingConfig, VersionedMappingConfig } from './types';
import merchantGatewayApi from '../api';

const BaseEndpoint = '/integrations-middleware-service/datamapper/merchants';

export const fetchMappingConfig = (merchantId: string): Promise<VersionedMappingConfig> =>
  merchantGatewayApi
    .get<VersionedMappingConfig>(`${BaseEndpoint}/${merchantId}/config`)
    .then(response => response.data);

export const fetchMappingConfigs = (merchantId: string): Promise<VersionedMappingConfig[]> =>
  merchantGatewayApi
    .get<VersionedMappingConfig[]>(`${BaseEndpoint}/${merchantId}/configs`)
    .then(response => response.data);

export const saveMappingConfig = (merchantId: string, data: MappingConfig): Promise<MappingConfig> =>
  merchantGatewayApi.post<MappingConfig>(`${BaseEndpoint}/${merchantId}/config`, data).then(response => response.data);
